import { Animal } from "../../../redux/animals/animals-types";

export enum OrderColumn {
  device_time_utc = "device_time_utc",
  full_id = "full_id",
  serial = "serial",
}

export enum OrderDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export type OrderBy = {
  column: OrderColumn;
  direction: OrderDirection;
};

export type TableRow = {
  time_correction_sec: number | null;
  is_time_corrected: boolean;
  time_utc: string;
  device_time_utc: string;
  full_id: string;
  serial: string;
  sensor_value: string | "";
  sensor_unit: string | "";
  animal_name: string;
  animal_species: string;
  file_names: string[];
  // supporting fields used for display logic
  animals: Animal[];
  animal_conflict: boolean;
};
export type BaseColumnField = keyof TableRow;

export type ParsedCsvRow = {
  time_correction_sec: string;
  time_utc: string;
  device_time_utc: string;
  full_id: string;
  serial: string;
  sensor_value: string; // can be ""
  sensor_type: string; // can be ""
  files: string; // actually file ids
  animal_ids: string; // can be ""
};
